import(/* webpackMode: "eager" */ "/home/ubuntu/Websites/.releases/2solutions-checkout-20261009/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Websites/.releases/2solutions-checkout-20261009/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Websites/.releases/2solutions-checkout-20261009/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Websites/2solutions/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Websites/2solutions/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
